export const emptyGuid = (value) => value !== "00000000-0000-0000-0000-000000000000";
export const greaterThanZero = (value) => value > 0;
export const iban = (value) => new RegExp(/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$/).test(value);
export const notEqualToZero = (value) => value != 0;
